export enum ViewMode {
  SupportWidget = 'support-widget',
  CSATSurvey = 'csat-survey',
  Drawer = 'drawer',
  // A minimal view mode avoids rendering the header (but still renders any
  // active top content) and lets the host surface control the sizing
  Minimal = 'minimal',
}

export type ViewParams = {
  height: string;
  width: string;
  mobileBreakpoint?: number;
};
